module.exports = __webpack_public_path__ + "static/img/fun_corner.35f0f8d6.png";